import { render, staticRenderFns } from "./CompanyIntro.vue?vue&type=template&id=1c10df8a&"
import script from "./CompanyIntro.vue?vue&type=script&lang=js&"
export * from "./CompanyIntro.vue?vue&type=script&lang=js&"
import style0 from "./CompanyIntro.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports